import { render, staticRenderFns } from "./ManageEvents.vue?vue&type=template&id=2df07fe9&scoped=true&"
import script from "./ManageEvents.vue?vue&type=script&lang=js&"
export * from "./ManageEvents.vue?vue&type=script&lang=js&"
import style0 from "./ManageEvents.vue?vue&type=style&index=0&id=2df07fe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df07fe9",
  null
  
)

export default component.exports